import { CASEBUSI_MNG } from '@/api/apiModules'
export default {
  viewType: 'form',
  module: CASEBUSI_MNG,
  params: null,
  view: {
    title: '创建用例',
    labelPosition: 'right',
    labelWidth: '170px',
    width: '700px',
    content: [
      {
        $id: 'testCaseName',
        $type: 'input',
        label: 'testcaseMng.testCaseName',
        $el: {
          placeholder: '请输入用例名',
          suffixIcon: 'el-icon-edit'
        },
        rules: [
          {
            notEmpty: 'testcaseMng.testCaseName'
          }
        ]
      },
      {
        $id: 'testCaseContent',
        $type: 'input',
        $el: {
          placeholder: '请输入用例内容',
          type: 'textarea',
          rows: 5
        },
        label: 'testcaseMng.testCaseContent',
        rules: [
          {
            notEmpty: 'testcaseMng.testCaseContent'
          }
        ]
      },
      {
        $id: 'userDemand',
        $type: 'input',
        label: 'testcaseMng.testUserDemand',
        $el: {
          placeholder: '请输入用户诉求',
          suffixIcon: 'el-icon-edit',
          type: 'textarea',
          rows: 5
        },
        rules: [
          {
            notEmpty: 'testcaseMng.testUserDemand'
          }
        ]
      },
      {
        $id: 'testCaseScene',
        $type: 'input',
        label: 'testcaseMng.testCaseScene',
        $el: {
          placeholder: '请输入用例场景',
          suffixIcon: 'el-icon-edit',
          type: 'textarea',
          rows: 3
        },
        rules: [
          {
            notEmpty: 'testcaseMng.testCaseScene'
          }
        ]
      },
      {
        $id: 'testCaseStep',
        $type: 'input',
        label: 'testcaseMng.testCaseStep',
        $el: {
          placeholder: '请输入用户步骤',
          suffixIcon: 'el-icon-edit',
          type: 'textarea',
          rows: 5
        },
        rules: [
          {
            notEmpty: 'testcaseMng.testCaseStep'
          }
        ]
      },
      {
        $id: 'testCaseExpectedResult',
        $type: 'input',
        label: 'testcaseMng.testCaseExpectedResult',
        $el: {
          placeholder: '请输入预期结果',
          suffixIcon: 'el-icon-edit',
          type: 'textarea',
          rows: 3
        },
        rules: [
          {
            notEmpty: 'testcaseMng.testCaseExpectedResult'
          }
        ]
      },
      {
        $id: 'compatibleDTOList',
        $type: 'sky-product-os-relate',
        label: '支持的产品及操作系统',
        $el: {
          checkDuplicateVersion: true
        },
        rules: [
          {
            // notEmpty: '支持的产品及操作系统'
          }
        ]
      }
    ]
  }
}
